import { Component, ViewEncapsulation, input, output } from '@angular/core';

export type ButtonVariant = 'primary' | 'outline' | 'ghost-dark';

@Component({
  selector: 'ds-button',
  templateUrl: './button.html',
  styleUrl: './button.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent {
  variant = input<ButtonVariant>('primary');
  disabled = input(false);
  type = input<'button' | 'submit' | 'reset'>('button');

  clicked = output<MouseEvent>();
}
